"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var InputField_1 = __importDefault(require("../Fields/InputField"));
var card_validator_1 = __importDefault(require("card-validator"));
function CardNumberField(props, ref) {
    var validate = props.validate, rest = __rest(props, ["validate"]);
    var validateCardNumber = function (value) {
        if (!card_validator_1.default.number(value).isValid) {
            return 'Please enter a valid card number';
        }
        return validate === null || validate === void 0 ? void 0 : validate(value);
    };
    return (react_1.default.createElement(InputField_1.default, __assign({ ref: ref, name: 'cardNumber', label: 'Card Number', placeholder: 'Card Number', validate: validateCardNumber, maxLength: 19, autoComplete: 'cc-number' }, rest)));
}
exports.default = react_1.default.forwardRef(CardNumberField);
